<template>
  <el-form-item class="rc-big-file-upload-runtime"
                :class="{'table-big-file': isTable}"
                ref="uploadForm"
                :prop="getProp"
                :rules="rules"
                :label-width="labelParameter.width">
    <!-- 表格外面 -->
    <template v-if="!isTable">
      <div v-if="labelParameter.showSlot"
           :class="['control-label', labelParameter.className]"
           slot="label"
           :title="component.name">{{labelParameter.labelName}}</div>
      <span v-else slot="label" :title="component.name">{{ labelParameter.labelName }}</span>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-upload
        ref="uploadControl"
        class="rc-big-file-upload-control"
        name="files"
        action=""
        multiple
        :before-upload="beforeUpload"
        :show-file-list="false"
        :http-request="bigFileUpload">
        <el-button class="upload-button" type="text">添加附件</el-button>
      </el-upload>
      <div class="accessory">
        <template v-if="fileLists.length > 1">
          <el-dropdown v-if="fileLists.length" placement="bottom-start" :hide-on-click='false'>
        <span class="el-dropdown-link">
          <span class="multiple-accessory">{{fileLists[0] && fileLists[0].name}}</span> ( {{ getUploadSuccessFileLength }} )<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
            <el-dropdown-menu ref="uploadDropdownMenu" class="rc-file-dropdown" slot="dropdown" v-if="fileLists.length > 1">
              <el-dropdown-item v-for="item in fileLists" :key="item.url">
                <a class="item" :title="item.name">{{ item.name }}</a>
                <i v-if="$refs.uploadForm.$el.getAttribute('disabled') !== 'disabled'"
                   class="el-icon-circle-close"
                   @click.stop="delFile(item, fileLists)"></i>
                <div v-if="item.loading" class="progress"><el-progress color="#53A6E8" :stroke-width="3" :show-text="false" :percentage="getPercentage(item)"></el-progress></div>
                <div class="big-file-down">
                  <div class="down" @click.stop="downFile(item)"><i class="el-icon-download"></i>下载</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <div v-if="fileLists[0]" class="item item-one-file">
            <span class="file-name" :title="fileLists[0].name">{{ fileLists[0].name }}</span>
            <i v-if="$refs.uploadForm.$el.getAttribute('disabled') !== 'disabled'" class="el-icon-circle-close"
               @click.stop="delFile(fileLists[0], fileLists)"></i>
            <div v-if="fileLists[0].loading" class="progress"><el-progress color="#53A6E8" :stroke-width="3" :show-text="false" :percentage="getPercentage(fileLists[0])"></el-progress></div>
            <div class="big-file-down">
              <div class="down" @click.stop="downFile(fileLists[0])"><i class="el-icon-download"></i>下载</div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <!-- 表格里面 -->
    <div v-else class="table-big-file-content">
      <div class="table-accessory">
        <el-tooltip effect="dark" popper-class="file-tooltip big-file-tooltip" transition="''" :visible-arrow="false" class="file-name" placement="bottom">
          <div class="accessory-content">
            <span v-if="fileLists.length > 0">{{fileLists[fileLists.length - 1].name}}</span>
            <div v-if="fileLists.length > 0 && fileLists[fileLists.length - 1].loading" class="progress">
              <el-progress color="#53A6E8" :stroke-width="3" :show-text="false" :percentage="getPercentage(fileLists[fileLists.length - 1])"></el-progress>
            </div>
          </div>
          <div class="title" slot="content">
            <div class="down" @click.stop="downFile(fileLists[fileLists.length - 1])"><i class="el-icon-download"></i>下载</div>
          </div>
        </el-tooltip>
      </div>
      <el-upload
        ref="uploadControl"
        class="rc-big-file-upload-control"
        name="files"
        action=""
        multiple
        :before-upload="beforeUpload"
        :show-file-list="false"
        :http-request="bigFileUpload">
        <el-button class="upload-button" type="text">添加附件</el-button>
      </el-upload>
    </div>
  </el-form-item>
</template>

<script>
import {componentMixin, inputMixin} from './mixins'
import PromiseLimit from './utils/promiseLimit.js'
import moment from 'moment'
import md5 from 'md5'
export default {
  name: 'rc-big-file-upload',
  mixins: [componentMixin, inputMixin],
  props: ['component', 'value', 'index', 'labelParameter', 'isTable'],
  inject: ['initState', 'initCount'],
  data () {
    return {
      // 当前请求域名
      requestUrl: this.component.properties.requestUrl || 'http://172.16.10.221:5100',
      fileList: [],
      uploading: false,
      fileLists: [],
      timeOut: null,
      isUpload: false,
      // 单个切片大小
      size: 10
    }
  },
  watch: {
    'initState.state' (val) {
      if (val) {
        this.initFileList()
      }
    },
    'initCount.value' (val) {
      if (val > 0) {
        this.$set(this, 'fileList', [])
        this.$set(this, 'fileLists', [])
      }
    },
    'fileLists.length' (val) {
      if (val > 1) {
        this.$nextTick(() => this.isUpload && this.$refs && this.$refs.uploadDropdownMenu && this.$refs.uploadDropdownMenu.dropdown && this.$refs.uploadDropdownMenu.dropdown.show())
      }
    }
  },
  methods: {
    initFileList () {
      this.fileLists = []
      if (this.value) {
        let list = this.value.split('$.$').filter(item => item.trim() !== '')
        list.forEach(n => {
          if (n && n !== 'undefined') {
            this.fileLists.push({name: n.split(',/')[0], url: '/' + n.split(',/')[1]})
          }
        })
      }
    },
    beforeUpload (file) {
      if (!this.isUpload) {
        this.isUpload = true
      }
      this.rules.push({
        validator: (rule, value, callback) => {
          if (this.uploading) {
            callback(new Error('文件上传中，请稍候'))
          } else {
            callback()
          }
        }
      })
      // 因为上面那个校验是失焦就触发，选完文件就会触发失焦
      setTimeout(() => { this.uploading = true }, 100)
      this.fileLists.push({name: file.name, url: file.uid, loading: true, file, progress: 0})
    },
    async bigFileUpload (files) {
      let file = files.file
      let time = moment().format('YYYYMMDDHHmmss')
      let fileMd5 = md5('ak0000000386' + file.name + file.size + time)
      // token appId + 当前日期 + appSecret
      let token = md5('ak0000000386' + moment().format('YYYYMMDD') + 'a0c1f208de028ofd12ef')
      // 上传路径 以 '/' 结尾
      let fileDir = `/${moment().format('YYYYMMDD')}/`
      let fileInfo = {
        fileMd5,
        fileDir,
        token,
        app_id: 'ak0000000386',
        fileSize: file.size,
        fileName: file.name,
        chunks: Math.ceil(file.size / (this.size * 1024 * 1024)), // 10M/个切片
        uploadDate: time
      }
      try {
        // 上传文件准备 - 发送上传文件信息
        await this.readyUpload(fileInfo)
        let chunksData = this.chunkFile(file)
        // 限流并发请求, 最多同时发送6个请求
        await this.uploadExcute(chunksData, {fileInfo, fileMd5: fileMd5, flag: file.uid})
        // 上传完成
        let sucessMsg = await this.uploadSuccess(fileInfo)
        this.updateFile(sucessMsg, file)
      } catch (e) {
        this.uploadFailed('', file)
      }
    },
    // 发送上传文件信息
    readyUpload (fileInfo) {
      let data = new FormData()
      data.append('fileMd5', fileInfo.fileMd5)
      data.append('fileDir', fileInfo.fileDir)
      data.append('token', fileInfo.token)
      data.append('app_id', fileInfo.app_id)
      data.append('fileSize', fileInfo.fileSize)
      data.append('fileName', fileInfo.fileName)
      data.append('chunks', fileInfo.chunks)
      data.append('uploadDate', fileInfo.uploadDate)
      return this.$axios.post(`${this.requestUrl}/api/ready-upload-file`, data).then(res => {
        if ([1, 103, 104, 105].indexOf(parseInt(res.data.code)) !== -1) {
          return Promise.resolve(res.data)
        } else {
          throw new Error(res.data.result.desc)
        }
      })
    },
    // 发送上传文件内容
    chunkFile (file) {
      // 分片
      let chunkSize = this.size * 1024 * 1024
      let chunksData = [] // 分片数据
      if (file.size > chunkSize) {
        let start = 0
        let end = 0
        while (true) {
          end += chunkSize
          let blob = file.slice(start, end)
          start += chunkSize
          if (!blob.size) { // 截取的数据为空 则结束
            // 拆分结束
            break
          }
          chunksData.push(blob)// 保存分段数据
        }
      } else {
        chunksData.push(file.slice(0))
      }
      return chunksData
    },
    // 上传方法
    upload (file, parmas) {
      let data = new FormData()
      data.append('fileMd5', parmas.fileMd5)
      data.append('chunk', parmas.index)
      data.append('file', file)
      return this.$axios.post(`${this.requestUrl}/api/upload`, data)
    },
    async uploadExcute (chunksData, params, failedChunksIndex, countFailedTimes = 0, chunksProgress = 0) {
      let promiseLimit = new PromiseLimit(6, chunksData, failedChunksIndex, this.upload, {fileMd5: params.fileMd5, flag: params.flag}, this.updateProgress, chunksProgress)
      chunksProgress = await promiseLimit.excute()
      // 检查是否有分片没上传, 如果,则重新上传, 如果没有发送合并请求
      let uploadResult = await this.readyUpload(params.fileInfo)
      if ([1, 103, 104, 105].indexOf(parseInt(uploadResult.code)) !== -1) {
        if (typeof uploadResult.result.chunkSet === 'object' && uploadResult.result.chunkSet.length > 0 && countFailedTimes < 3) {
          countFailedTimes++
          let failedChunksIndex = uploadResult.result.chunkSet || []
          await this.uploadExcute(chunksData, params, failedChunksIndex, countFailedTimes, chunksProgress)
        } else {
          // 整合上传文件信息,并更新
          return Promise.resolve()
        }
      } else {
        this.$message.error(uploadResult.result.desc)
        throw new Error(uploadResult.result.desc)
      }
    },
    uploadSuccess (fileInfo) {
      let data = new FormData()
      data.append('fileMd5', fileInfo.fileMd5)
      data.append('fileDir', fileInfo.fileDir)
      data.append('app_id', fileInfo.app_id)
      data.append('fileName', fileInfo.fileName)
      data.append('uploadDate', fileInfo.uploadDate)
      return this.$axios.post(`${this.requestUrl}/api/uploadSuccess`, data).then(res => {
        if (res.data.code === 1) {
          this.$message.success(fileInfo.fileName + '上传成功')
          return Promise.resolve(res.data)
        } else {
          this.$message.error(fileInfo.fileName + res.data.result.desc)
          throw new Error(res.data.result.desc)
        }
      })
    },

    uploadFailed (err, file) {
      let i = this.fileLists.findIndex(f => f.url === file.uid)
      i !== -1 && this.fileLists.splice(i, 1)
      this.uploading = false
      this.$refs.uploadForm.validate()
      this.$message.error(`${file.name} 上传失败，请重新上传`)
      throw new Error(err)
    },
    updateFile (res, file) {
      let findFile = this.fileLists.find(f => f.loading && f.url === file.uid)
      this.uploading = false
      this.$refs.uploadForm.validate()
      let name = res.result.file
      let url = res.result.dir
      if (!this.isTable) {
        this.update(`${this.value || ''}$.$${name},${url}`)
      } else {
        this.update(`$.$${name},${url}`)
      }
      if (findFile) {
        findFile.progress = 100
        findFile.url = res.result.dir
        findFile.loading = false
      } else {
        // 表格里面的文件上传，只需要保存最后一个即可
        if (!this.isTable) {
          this.fileLists.push({name: res.result.file, url: res.result.dir})
        } else {
          this.fileLists = [{name: res.result.file, url: res.result.dir}]
        }
      }
      this.$nextTick(() => {
        // 上传成功之后重新校验
        this.$refs.uploadForm.validate('change')
      })
    },
    downFile (file) {
      if (file.loading) {
        return this.$message.info('该文件正在上传中，请上传完成后再试')
      } else {
        window.open(`${this.requestUrl}/download${file.url}`)
      }
    },
    delFile (file, fileList) {
      // 删除前取消上传状态
      this.uploading = false
      this.$refs.uploadForm.validate()
      let index = fileList.findIndex(item => item.url === file.url)
      if (this.value) {
        let list = this.value.split('$.$')
        list.splice(index + 1, 1)
        this.update(list.join('$.$'))
      }
      // 如果文件正在上传 取消正在上传的文件
      file.loading && this.$refs.uploadControl.abort(file.file)
      this.fileLists.splice(index, 1)
      index !== -1 && this.fileList.splice(index, 1)
    },
    updateProgress (flag, index, chunksCount) {
      // 分片进度条
      let item = this.fileLists.find(f => f.url === flag)
      // 按每个分片来算进度
      this.$set(item, 'progress', Math.floor(index / chunksCount * 100))
    }
  },
  beforeDestroy () {
    // 如果有文件正在上传、取消上传
    let findFiles = this.fileLists.filter(f => f.loading)
    findFiles.length > 0 && findFiles.forEach(f => this.$refs.uploadControl.abort(f.file))
  },
  computed: {
    getUploadSuccessFileLength () {
      return this.fileLists.filter(c => !c.loading).length
    },
    // 文件过小的时候，定时还没走完，文件已经上传完成，会导致进度冒了。。
    getPercentage () {
      return item => {
        if (item.progress >= 100) {
          item.progress = 100
          return 100
        } else {
          return item.progress
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .rc-big-file-upload-runtime {
    .el-form-item__label{
      height: 48px;
      line-height: 48px;
      .control-label{
        font-size: 13px;
        white-space: pre-line;
        width: 100%;
        height: 48px;
        line-height: 22px;
        word-wrap: break-word;
        word-break: break-all;
        text-align: right;
      }
    }
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 48px;
     .component-explain-tooltip {
       top: 17px;
     }
      .rc-big-file-upload-control {
        width: 61px;
        .el-upload {
          .upload-button {
            & > span {
              text-decoration: underline;
            }
          }
        }
      }

      .accessory {
        width: calc(100% - 61px);
        padding-left: 15px;
        height: 100%;

        .item-one-file {
          width: 100%;
          position: relative;
          cursor: pointer;
          height: 30px;
          line-height: 30px;
          -moz-box-sizing: border-box; /*Firefox3.5+*/
          -webkit-box-sizing: border-box; /*Safari3.2+*/
          -o-box-sizing: border-box; /*Opera9.6*/
          -ms-box-sizing: border-box; /*IE8*/
          box-sizing: border-box;

          .file-name {
            display: inline-block;
            width: calc(100% - 40px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 30px;
            height: 30px;
            color: #55ACF1;
            &:hover{
              color: #318ED9;
              text-decoration: underline;
            }
          }

          .el-icon-loading {
            position: absolute;
            top: 8.5px;
          }

          .el-icon-circle-close {
            &:before {
              position: relative;
              top: -14px;
            }
          }

          &:hover {
            color: #54ABF1;

            .big-file-down {
              display: block;
            }
          }

          .big-file-down {
            position: absolute;
            color: #fff;
            width: 80px;
            height: 30px;
            background: rgba(0, 0, 0, .72);
            border-radius: 4px;
            line-height: 30px;
            z-index: 9999;
            left: 70px;
            top: 25px;
            display: none;

            .icon {
              cursor: pointer;
            }

            .preivew, .down {
              height: 30px;
              line-height: 30px;
              text-align: center;
            }
          }

          @media (max-width: 1500px) {
            .big-file-down {
              left: 0;
            }
          }

          @media (max-width: 1500px) {
            .big-file-down {
              left: 0;
            }
          }
        }
        .progress {
          height: 5px;
          position: absolute;
          top: 34px;
          width: 100%;
        }
      }
    }

    i.el-icon-upload {
      color: #3a8ee6;
    }

    .el-upload {
      text-align: left;

      .el-upload-dragger {
        width: 250px;
        height: 150px;
      }
    }

    .el-form-item__content {
      .el-form-item__error {
        padding-top: 4px;
      }
    }
    .el-form-item__content:before{
      content: none;
    }
    .el-dropdown-link {
      cursor: pointer;
      .multiple-accessory{
        color: #54ABF1;
        &:hover{
          color: #318ED9;
          text-decoration: underline;
        }
      }
    }

    .el-icon-circle-close {
      color: red;
      opacity: 0;
      margin-left: 20px;
    }

    .item {
      &:hover {
        .el-icon-circle-close {
          opacity: 1;
        }
      }
    }
  }
  .rc-big-file-upload-dialog {
    .el-dialog {
      .el-dialog__body {
        padding: 15px 15px;
        & > .hint {
          padding: 15px 33px;
          line-height: 20px;
          .file-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: 200px;
            vertical-align: bottom;
          }
        }
        .file-select-list {
          .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #EBEBEB;
            font-size: 13px;
            color: #323232;
            padding-bottom: 5px;
            .right {
              text-align: center;
              width: 80px;
            }
            .left {
              padding-left: 40px;
            }
          }
          .file-content {
            color: #323232;
            height: 202px;
            overflow: auto;
            .item {
              padding: 0 10px 0 5px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 30px;
              line-height: 30px;
              .file-name {
                width: 300px;
                .name {
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  display: inline-block;
                  vertical-align: bottom;
                  width: 300px;
                  cursor: pointer;
                  .el-checkbox {
                    .el-checkbox__label {
                      color: #323232;
                    }
                    .el-checkbox__inner {
                      border-radius: 2px;
                      background-color: #fff;
                      border-color: #C2C3C4;
                      &:after {
                        border-color: #55ACF1;
                      }
                    }
                    .is-checked {
                      .el-checkbox__inner {
                        border-color: #55ACF1;
                      }
                    }
                  }
                }
                .name-hint {
                  width: 180px;
                }
              }
              .size {
                width: 75px;
                text-align: right;
              }
            }
            .checked-item {
              background-color: #f7fbfe;
            }
          }
          .file-footer {
            border-top: 1px solid #EBEBEB;
            padding-top: 10px;
          }
        }
      }
      .el-dialog__footer {
        padding-top: 0;
        .dialog-footer {
          .hint-button {
            .el-button {
              width: 104px;
              height: 30px;
              border: 1px solid rgba( 84, 171, 241, 1);
              border-radius: 4px;
              padding: 0;
              color: #54ABF1;
            }
          }
          .select-file {
            .el-button {
              padding: 0;
              width: 104px;
              height: 30px;
            }
          }
        }
      }
    }
  }
  .table-big-file {
    .el-form-item__content {
      .table-big-file-content {
        height: 28px;
        line-height: 28px;
        border: 1px solid #C2C3C4;
        display: flex;
        width: 100%;
        border-radius: 4px;
        .table-accessory {
          width: calc(100% - 55px);
          padding-left: 5px;
          height: 28px;
          line-height: 28px;
          position: relative;
          .accessory-content {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            span {
              font-size: 12px;
              color: #2A2929;
              cursor: pointer;
            }
            .progress {
              position: absolute;
              width: 100%;
              bottom: 3.5px;
              left: 5px;
            }
          }
        }
        .rc-big-file-upload-control {
          width: 51px;
          height: 26px;
          line-height: 26px;
          font-size: 12px;
          .el-upload {
            height: 26px;
            line-height: 26px;
            .el-button {
              span {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
  .el-tooltip__popper.big-file-tooltip {
    height: 30px;
  }
  .rc-big-file-upload-runtime.is-error {
    .el-form-item__content {
      .table-big-file-content {
        border-color: #F56C6C;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-big-file-upload.vue